'use strict';

namespace Search {

    class OccupancyPicker {

        // bound attributes
        model: SearchOccupancy[];
        maxRooms: number;
        maxAdults: number;
        maxChildren: number;
        maxChildAge: number;
        maxAdultsInAdditionalRooms: number;
        maxChildrenInAdditionalRooms: number;
        select: () => void;
        show: boolean;

        // local variables
        private localModel: SearchOccupancy[];
        private children: number;
        private invalid: boolean = false;

        private ranges: any = {
            rooms: [],
            childAges: [],
            adults: [],
            children: [],
            adultsInAdditionalRooms: [],
            childrenInAdditionalRooms: []
        };

        private elements: any;
        private eventNamespace = 'occupancypicker';
        private html: JQuery;

        constructor (
            private $scope: ng.IScope,
            private $route: ng.route.IRouteService,
            private $timeout: ng.ITimeoutService,
            private animationUtil: any,
            private unifiedSearchService: any
        ) {
            this.html = $('html');
        }

        init (elements): void {
            this.elements = elements;

            this.$scope.$watch('op.show', (val) => {
                if (val != null) {
                    if (val) {
                        this.open();
                    } else {
                        this.close();
                    }
                }
            });

            this.$scope.$watch('op.localModel', (val) => {
                if (val) {
                    // sanity check each room and sum children
                    this.children = 0;
                    _.each(val, (room: SearchOccupancy, index: any) => {
                        room = room || new SearchOccupancy;
                        room.ChildAges = room.ChildAges || [];
                        room.Adults = room.Adults || 2;
                        val[index] = room;

                        this.children += room.ChildAges.length;
                    });
                    // assume we are no longer invalid
                    this.invalid = false;
                }
            }, true);

            this.$scope.$on('$destroy', () => {
                // unbind event listeners by namespace
                this.elements.overlay.off('.' + this.eventNamespace);
                this.elements.occupancyPicker.off('.' + this.eventNamespace);
                this.html.off('.' + this.eventNamespace);
            });

        }

        private open(): void {
            // ensure that numerical ranges are consistent with the current parameter attribues
            this.setRanges();

            // create a local copy of our model
            this.localModel = _.cloneDeep(this.model);

            this.checkRooms();

            this.animationUtil.lockScroll();
            this.elements.overlay.addClass('fade-in');

            this.html.on('keyup.' + this.eventNamespace, (event) => {
                // ESCAPE to close
                if (event.which === 27 && this.show) {
                    this.$scope.$apply(() => {
                        this.show = false;
                    });
                }
            });

            // close if overlay is clicked
            this.elements.overlay.on('click.'+this.eventNamespace, (event) => {
                this.$scope.$apply(() => this.closeClicked(null) );
            });

            this.elements.stage.on('click.'+this.eventNamespace, (event) => event.stopPropagation() );
        }

        private checkRooms(): void {
            if (this.maxRooms === 0 && this.localModel.length > 1) {
                // we need to reduce the occupancy array to a single room, summing values therein
                let mergedRoom = new SearchOccupancy;
                mergedRoom.Adults = 0;
                mergedRoom = _.reduce(this.localModel, merge, mergedRoom);
                this.localModel = [mergedRoom];
            }
            function merge(memo: SearchOccupancy, next: SearchOccupancy) {
                memo.Adults += next.Adults;
                memo.ChildAges = memo.ChildAges.concat(next.ChildAges);
                return memo;
            }
        }

        private setRanges(): void {
            this.ranges.rooms =  _.range(1, this.maxRooms + 1);
            this.ranges.adults = _.range(1, this.maxAdults + 1);
            this.ranges.adultsInAdditionalRooms = _.range(1, this.maxAdultsInAdditionalRooms + 1);
            this.ranges.children = _.range(0, this.maxChildren + 1);
            this.ranges.childrenInAdditionalRooms = _.range(0, this.maxChildrenInAdditionalRooms + 1);
            this.ranges.childAges = _.range(0, this.maxChildAge + 1);
        }

        public getAdultsPerRoom(index: number): number[] {
            return index === 0 ? this.ranges.adults : this.ranges.adultsInAdditionalRooms;
        }

        public getChidrenPerRoom(index: number): number[] {
            return index === 0 ? this.ranges.children : this.ranges.childrenInAdditionalRooms;
        }

        private close(): void {
            this.animationUtil.restoreScroll();
            this.elements.overlay.removeClass('fade-in');
            this.html.off('.' + this.eventNamespace);
        }

        public closeClicked (event): void {
            if ( event ) {
                event.preventDefault();
            }
            this.show = false;
            $(window).unbind('resize');
        }

        public done(): void {
            // validate
            if (!this.unifiedSearchService.validateOccupancy(this.localModel)) {
                this.invalid = true;
                return;
            }

            // apply changes from our local model to the true model
            this.model = _.cloneDeep(this.localModel);

            this.$timeout(() => {
                this.show = false;
            });
        }

        public addRoom($event): void {
            // required to prevent unexpected scrolling
            $event.stopPropagation();
            $event.preventDefault();
            this.localModel.push(new SearchOccupancy);
        }

        public removeRoom(index: number, $event): void {
            $event.stopPropagation();
            $event.preventDefault();
            this.localModel.splice(index, 1);
        }

    }

    angular
        .module('search')
        .directive('occupancyPicker', (): ng.IDirective => {
            return {
                restrict: 'E',
                scope: {},
                replace: true,
                controller: OccupancyPicker,
                controllerAs: 'op',
                bindToController: {
                    model: '=',
                    maxRooms: '=',
                    maxAdults: '=',
                    maxChildren: '=',
                    maxChildAge: '=',
                    maxAdultsInAdditionalRooms: '=',
                    maxChildrenInAdditionalRooms: '=',
                    select: '&',
                    show: '='
                },
                templateUrl: 'partials/search/occupancypicker',
                link: (
                    scope: ng.IScope,
                    el: ng.IAugmentedJQuery,
                    attr: ng.IAttributes,
                    controller : OccupancyPicker
                ) => {
                    const stage = el.find('.occupancy-picker');
                    const elements = {
                        overlay: el,
                        stage,
                        occupancyPicker: stage
                    };
                    controller.init(elements);
                }
            };
        });


}
